import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-btn-cell-renderer',
  styleUrls: ['./btn-cell-renderer.component.scss'],
  template: `
    <div class="wrapper-action-btn" >
      <button
        class="btn-action-style"
        [type]="type"
        [title]="disabled ? '' : title"
        [style.width.px]="width"
        [style.height.px]="height"
        [style.backgroundColor]="bgColor"
        [style.border]="border"
        [style.borderRadius]="borderRadius"
        [style.cursor]="cursor"
        (click)="onClick($event)"
        [disabled]="disabled"
        *ngIf="showBtn">
        <i [style.color]="color" [class]="'fa ' + classFontAwesome"></i>
      </button>

      <button
        class="btn-action-style"
        [type]="type2"
        [title]="title2"
        [style.width.px]="width2"
        [style.height.px]="height2"
        [style.backgroundColor]="bgColor2"
        [style.border]="border2"
        [style.borderRadius]="borderRadius2"
        [style.cursor]="cursor2"
        (click)="onClick2($event)"
        [disabled]="disabled2"
        *ngIf="showBtn2" >
        <i [style.color]="color2" [class]="'fa ' + classFontAwesome2"></i>
      </button>

      <button
        class="btn-action-style"
        [type]="type3"
        [title]="title3"
        [style.width.px]="width3"
        [style.height.px]="height3"
        [style.backgroundColor]="bgColor3"
        [style.border]="border3"
        [style.borderRadius]="borderRadius3"
        [style.cursor]="cursor3"
        (click)="onClick3($event)"
        [disabled]="disabled3"
        *ngIf="showBtn3" >
        <i [style.color]="color3" [class]="'fa ' + classFontAwesome3"></i>
      </button>

      <button
        class="btn-action-style"
        [type]="type4"
        [title]="title4"
        [style.width.px]="width4"
        [style.height.px]="height4"
        [style.backgroundColor]="bgColor4"
        [style.border]="border4"
        [style.borderRadius]="borderRadius4"
        [style.cursor]="cursor4"
        (click)="onClick4($event)"
        [disabled]="disabled4"
        *ngIf="showBtn4" >
        <i [style.color]="color4" [class]="'fa ' + classFontAwesome4"></i>
      </button>
    </div>
  `
})

export class BtnCellRendererComponent implements ICellRendererAngularComp {

  params: any;
  showBtn = true;
  classFontAwesome = '';
  bgColor = 'white';
  width = '30';
  height = '20';
  type = 'button';
  border = '1px solid #000';
  title = 'MyBtn 1';
  borderRadius = '3px';
  cursor = 'pointer';
  color = '#000';
  disabled = false;

  showBtn2 = false;
  classFontAwesome2 = '';
  bgColor2 = 'white';
  width2 = '30';
  height2 = '20';
  type2 = 'button';
  border2 = '1px solid #000';
  title2 = 'Mybtn 2';
  borderRadius2 = '3px';
  cursor2 = 'pointer';
  color2 = '#000';
  disabled2 = false;

  showBtn3 = false;
  classFontAwesome3 = '';
  bgColor3 = 'white';
  width3 = '30';
  height3 = '20';
  type3 = 'button';
  border3 = '1px solid #000';
  title3 = 'Mybtn 3';
  borderRadius3 = '3px';
  cursor3 = 'pointer';
  color3 = '#000';
  disabled3 = false;

  showBtn4 = false;
  classFontAwesome4 = '';
  bgColor4 = 'white';
  width4 = '30';
  height4 = '20';
  type4 = 'button';
  border4 = '1px solid #000';
  title4 = 'Mybtn 4';
  borderRadius4 = '3px';
  cursor4 = 'pointer';
  color4 = '#000';
  disabled4 = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.showBtn = this.params.showBtn !== undefined ? this.params.showBtn : true;
    this.classFontAwesome = this.params.classFontAwesome !== undefined ? this.params.classFontAwesome : '';
    this.bgColor = this.params.bgColor !== undefined ? this.params.bgColor : 'white';
    this.width = this.params.width !== undefined ? this.params.width : '30';
    this.height = this.params.height !== undefined ? this.params.height : '20';
    this.title = this.params.title !== undefined ? this.params.title : 'MyBtn 1';
    this.border = this.params.border !== undefined ? this.params.border : '1px solid #000';
    this.borderRadius = this.params.borderRadius !== undefined ? this.params.borderRadius : '3px';
    this.cursor = this.params.cursor !== undefined ? this.params.cursor : 'pointer';
    this.color = this.params.color !== undefined ? this.params.color : '#000';
    this.disabled = this.params.disabled !== undefined ? this.params.disabled : false;

    if (this.params.configSecondBtn !== undefined) {
      const CONFIG = this.params.configSecondBtn;
      this.showBtn2 = CONFIG.showBtn2 !== undefined ? CONFIG.showBtn2 : false;
      this.classFontAwesome2 = CONFIG.classFontAwesome2 !== undefined ? CONFIG.classFontAwesome2 : '';
      this.bgColor2 = CONFIG.bgColor2 !== undefined ? CONFIG.bgColor2 : 'white';
      this.width2 = CONFIG.width2 !== undefined ? CONFIG.width2 : '30';
      this.height2 = CONFIG.height2 !== undefined ? CONFIG.height2 : '20';
      this.title2 = CONFIG.title2 !== undefined ? CONFIG.title2 : 'Mybtn 2';
      this.border2 = CONFIG.border2 !== undefined ? CONFIG.border2 : '1px solid #000';
      this.borderRadius2 = CONFIG.borderRadius2 !== undefined ? CONFIG.borderRadius2 : '3px';
      this.cursor2 = CONFIG.cursor2 !== undefined ? CONFIG.cursor2 : 'pointer';
      this.color2 = CONFIG.color2 !== undefined ? CONFIG.color2 : '#000';
      this.disabled2 = CONFIG.disabled2 !== undefined ? CONFIG.disabled2 : false;
    }

    if (this.params.configThirdBtn !== undefined) {
      const CONFIG2 = this.params.configThirdBtn;
      this.showBtn3 = CONFIG2.showBtn3 !== undefined ? CONFIG2.showBtn3 : false;
      this.classFontAwesome3 = CONFIG2.classFontAwesome3 !== undefined ? CONFIG2.classFontAwesome3 : '';
      this.bgColor3 = CONFIG2.bgColor3 !== undefined ? CONFIG2.bgColor3 : 'white';
      this.width3 = CONFIG2.width3 !== undefined ? CONFIG2.width3 : '30';
      this.height3 = CONFIG2.height3 !== undefined ? CONFIG2.height3 : '20';
      this.title3 = CONFIG2.title3 !== undefined ? CONFIG2.title3 : 'Mybtn 3';
      this.border3 = CONFIG2.border3 !== undefined ? CONFIG2.border3 : '1px solid #000';
      this.borderRadius3 = CONFIG2.borderRadius3 !== undefined ? CONFIG2.borderRadius3 : '3px';
      this.cursor3 = CONFIG2.cursor3 !== undefined ? CONFIG2.cursor3 : 'pointer';
      this.color3 = CONFIG2.color3 !== undefined ? CONFIG2.color3 : '#000';
      this.disabled3 = CONFIG2.disabled3 !== undefined ? CONFIG2.disabled3 : false;
    }

    if (this.params.configFourthBtn !== undefined) {
      const CONFIG3 = this.params.configFourthBtn;
      this.showBtn4 = CONFIG3.showBtn4 !== undefined ? CONFIG3.showBtn4 : false;
      this.classFontAwesome4 = CONFIG3.classFontAwesome4 !== undefined ? CONFIG3.classFontAwesome4 : '';
      this.bgColor4 = CONFIG3.bgColor4 !== undefined ? CONFIG3.bgColor4 : 'white';
      this.width4 = CONFIG3.width4 !== undefined ? CONFIG3.width4 : '30';
      this.height4 = CONFIG3.height4 !== undefined ? CONFIG3.height4 : '20';
      this.title4 = CONFIG3.title4 !== undefined ? CONFIG3.title4 : 'Mybtn 4';
      this.border4 = CONFIG3.border4 !== undefined ? CONFIG3.border4 : '1px solid #000';
      this.borderRadius4 = CONFIG3.borderRadius4 !== undefined ? CONFIG3.borderRadius4 : '3px';
      this.cursor4 = CONFIG3.cursor4 !== undefined ? CONFIG3.cursor4 : 'pointer';
      this.color4 = CONFIG3.color4 !== undefined ? CONFIG3.color4 : '#000';
      this.disabled4 = CONFIG3.disabled4 !== undefined ? CONFIG3.disabled4 : false;
    }
  }

  refresh(): boolean {
    return true;
  }

  btnClickedHandler(): void {
    this.params.clicked(this.params.value);
  }

  onClick($event: any): void {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }

  onClick2($event: any): void {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.configSecondBtn.onClick2(params);
    }
  }

  onClick3($event: any): void {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.configThirdBtn.onClick3(params);
    }
  }

  onClick4($event: any): void {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.configFourthBtn.onClick4(params);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component.ts